export const isCapacitor = window.location.href.startsWith("capac")
